
const userTree = {
  state: {
    userTreeState: false,
    userTreeBranchId: '',
    userTreeBranchName: '',
    userTreeUserId: '',
    userTreeUserName: '',
    userTreeUserObj: '',  // 返回的 选择的用户 信息字符串

    userTreeSqType: '',
    userTreeOtherQuery: '',  // 扩展其他条件 ,json 字符串

    // << 多选
    userTreeIss: false,  // 是否多选
    userTreeDiaType: '',  // 弹窗类型  post-选择岗位
    userTreeGet: '',  // 弹窗返回数据
  },

  mutations: {
    SET_USERTREESTATE: (state, userTreeState) => {
      state.userTreeState = userTreeState
    },
    SET_USERTREEBRANCHID: (state, userTreeBranchId) => {
      state.userTreeBranchId = userTreeBranchId
    },
    SET_USERTREEBRANCHNAME: (state, userTreeBranchName) => {
      state.userTreeBranchName = userTreeBranchName
    },
    SET_USERTREEUSERID: (state, userTreeUserId) => {
      state.userTreeUserId = userTreeUserId
    },
    SET_USERTREEUSERNAME: (state, userTreeUserName) => {
      state.userTreeUserName = userTreeUserName
    },
    SET_USERTREESQTYPE: (state, val) => {
      state.userTreeSqType = val
    },
    

    SET_USERTREEUSEROBJ: (state, val) => {
      state.userTreeUserObj = val
    },
    SET_USERTREEOTHERQUERY: (state, val) => {
      state.userTreeOtherQuery = val
    },

    // << 多选
    SET_USERTREE_ISS: (state, val) => {
      state.userTreeIss = val
    },
    SET_USERTREE_DIATYPE: (state, val) => {
      state.userTreeDiaType = val
    },
    SET_USERTREE_GET: (state, val) => {
      state.userTreeGet = val
    },

    
    
  },

  actions: {
    
  }
}

export default userTree
